import { format, startOfMonth } from 'date-fns';
import React, { useEffect, useState } from 'react';
import { useRef } from 'react';
import ReactHtmlTableToExcel from 'react-html-table-to-excel';
import { toast } from 'react-toastify';
import Loader from '../../../Shared/Loader';
import logo from '../../../../assets/images/logo.jpeg';
import { useReactToPrint } from 'react-to-print';
import BusinessInfo from '../../../Shared/BusinessInfo';

const ProfitStatementAdvance = () => {
    const [isLoaded, setIsLoaded] = useState(false)
    const [salesProfit, setSalesProfit] = useState([]);
    const [partialProfit, setPartialProfit] = useState([]);
    const [collectionProfit, setCollectionProfit] = useState([]);
    const [incomes, setIncomes] = useState([]);
    const [expenses, setExpenses] = useState([]);
    const [bankAccounts, setBankAccounts] = useState([]);
    const [opening, setOpening] = useState(0);
    const [details, setDetails] = useState('');
    const [isFilter, setIsFilter] = useState(false);
    const [loading, setLoading] = useState(true);
    const [months, setMonths] = useState([]);
    const componentRef = useRef();

    const date = new Date();
    const today = format(date, "yyyy-MM-dd");

    const currentDate = new Date();
    const firstDate = startOfMonth(currentDate);
    const dateFormat = 'yyyy-MM-dd';
    const firstDateFormatted = format(firstDate, dateFormat);


    const givenDate = new Date(`${details?.startDate ? details?.startDate : firstDateFormatted}`);
    const monthName = givenDate.toLocaleString('default', { month: 'long' });
    const year = givenDate.getFullYear();

    const options = {
        timeZone: 'Asia/Dhaka',
        hour12: false,
    };
    const currentTime = new Date().toLocaleString('en-US', options);

    const generatePrint = useReactToPrint({
        content: () => componentRef.current,
        documentTitle: `Profit Statement Of ${details?.accountName}`,

    })

    useEffect(() => {
        fetch('https://servers.thakurgaonexpress.com/rupkotha/getsalesmonths')
            .then(res => res.json())
            .then(data => {
                setMonths(data)
                setLoading(false)
            })
    }, []);

    useEffect(() => {
        fetch('https://servers.thakurgaonexpress.com/rupkotha/getprofitbalancesalesadvance')
            .then(res => res.json())
            .then(data => {
                setSalesProfit(data?.totalSaleProfit[0]);
                setPartialProfit(data?.totalPartialSaleProfit[0])
                setCollectionProfit(data?.totalCollectionProfit[0])
                setLoading(false)
                console.log(data);
            })
    }, [])
    useEffect(() => {
        fetch('https://servers.thakurgaonexpress.com/rupkotha/getprofitbalanceincomes')
            .then(res => res.json())
            .then(data => {
                const filter = data.filter(income => !income._id.includes("Capital") && !income._id.includes("Opening"))
                setIncomes(filter);
                setLoading(false)
            })
    }, [])
    useEffect(() => {
        fetch('https://servers.thakurgaonexpress.com/rupkotha/getprofitbalanceexpenses')
            .then(res => res.json())
            .then(data => {
                const filter = data.filter(expense => !expense._id.includes("Fixed") && !expense._id.includes("Profit"))
                setExpenses(filter);
                setLoading(false)
            })
    }, [])

    const handleFilteredData = e => {
        e.preventDefault();
        const month = e.target.month.value;

        const url = `https://servers.thakurgaonexpress.com/rupkotha/getprofitbalancesalesadvancefiltered?month=${month}`
        fetch(url)
            .then(res => res.json())
            .then(data => {
                console.log(data);
                setSalesProfit(data?.totalSaleProfit[0]);
                setPartialProfit(data?.totalPartialSaleProfit[0])
                setCollectionProfit(data?.totalCollectionProfit)
                setIsFilter(true);
                setIsLoaded(true);
                setDetails({ startDate: month, range: month + " to " + month });
            })
        const url2 = `https://servers.thakurgaonexpress.com/rupkotha/getprofitbalanceincomesfiltered?month=${month}`
        fetch(url2)
            .then(res => res.json())
            .then(data => {
                const filter = data.filter(income => !income._id.includes("Capital"));
                const filter2 = filter.filter(income => !income._id.includes("Opening"));
                setIncomes(filter2);
            });

        const url3 = `https://servers.thakurgaonexpress.com/rupkotha/getprofitbalanceexpensesfiltered?month=${month}`
        fetch(url3)
            .then(res => res.json())
            .then(data => {
                const filter = data.filter(expense => !expense._id.includes("Fixed"));
                const filter2 = filter.filter(expense => !expense._id.includes("Profit"));
                setExpenses(filter2);
            })
    }


    const totalIncome = incomes?.reduce((total, currentValue) => total + parseInt(currentValue?.totalAmount), 0);
    const totalExpense = expenses?.reduce((total, currentValue) => total + parseInt(currentValue.totalAmount), 0);

    if (loading) {
        return <Loader />
    }
    return (
        <div className='mx-2'>
            <h2 className='mt-8 text-center text-3xl font-bold'>Advance Profit Report</h2>
            <div className='flex justify-center items-center'>
                <form onSubmit={handleFilteredData} className='mt-12 flex flex-col lg:flex-row justify-center items-center'>
                    <div class="form-control w-full mx-auto lg:w-60 max-w-xs lg:mr-2">
                        <label class="label">
                            <span class="label-text">Select Month</span>
                        </label>
                        <select name='month' className="select select-bordered w-full max-w-xs">
                            {months.map(month => (<option>{month?.month}</option>))}
                        </select>
                    </div>
                    <input type='submit' value='Search' className='btn btn-md btn-error w-80 mx-auto lg:w-20 text-white mt-4 lg:mt-9 lg:ml-2' />
                    <div>
                    </div>
                </form>
            </div>
            <div className='text-right'>
                <ReactHtmlTableToExcel
                    id="test-table-xls-button"
                    className="btn btn-error text-white btn-xs mt-2 lg:mt-0"
                    table="table-to-xls"
                    filename={`Bank Statement- ${details.accountName}`}
                    sheet={`bankstatement-${details.accountName}`}
                    buttonText="Export to exel" />
                <button className='btn btn-success btn-xs ml-2 text-white' onClick={generatePrint}>Print</button>
            </div>
            <div ref={componentRef}>
                <div className='flex justify-center items-center mt-8'>
                    <div>
                        <img src={BusinessInfo.img} className="w-20 lg:w-44 lg:mr-20 lg:mb-4" alt="" />
                    </div>
                    <div className='lg:mr-40'>
                        <h1 className='text-xl lg:text-4xl text-textPrimary text-center'>{BusinessInfo.fullName}</h1>
                      {/* <h1 className='text-sm lg:text-xl text-textPrimary text-center'>{BusinessInfo.dealer}</h1> */}
                        <h1 className='text-xs text-textPrimary text-center'>{BusinessInfo.address}</h1>
                        <h1 className='text-xs lg:text-xl text-textPrimary text-center'>{BusinessInfo.mobile}</h1>
                    </div>
                </div>
                <div class="flex items-center justify-between">
                    <hr class="border-b border-gray-300 w-full mt-4 mb-px" />
                    <hr class="border-b border-gray-300 w-full mt-4 mb-px" />
                </div>
                <div class="flex items-center justify-between">
                    <hr class="border-b border-gray-300 w-full my-px" />
                    <hr class="border-b border-gray-300 w-full my-px" />
                </div>

                <h1 className='text-lg font-bold text-center mt-8'>Profit Sheet For the Month ({monthName}-{year})</h1>
                <div className='text-left ml-20 mt-8 text-xs'>
                    <h4>Report Type: <span className='font-bold'>Profit Sheet</span></h4>
                    <h4>Report Date Range: {details?.range ? details?.range : firstDateFormatted + " to " + today}</h4>
                    <h4>Report Time: {currentTime}</h4>
                </div>
                <div className='mb-20'>
                    <div class="overflow-x-auto mt-4 text-xs">
                        <table id='table-to-xls' class="table w-full text-center shadow-xl text-xs rounded-lg">
                            <thead>
                                <tr>
                                    <th className='bg-primary text-white normal-case'>SL</th>
                                    <th className='bg-primary text-white normal-case'>Income/Expense Head</th>
                                    <th className='bg-primary text-white normal-case'>Amount</th>
                                    <th className='bg-primary text-white normal-case'>Amount</th>
                                </tr>

                            </thead>
                            <tbody>
                                <tr>
                                    <td className='border border-primary'>1</td>
                                    <td className='border border-primary text-left'>Total Full Cash Sale/Profit</td>
                                    <td className='border border-primary'>{salesProfit?.totalSales}</td>
                                    <td className='border border-primary'>{(salesProfit?.totalSales - salesProfit?.totalProfit).toFixed(2)}</td>
                                </tr>

                            </tbody>
                            <tbody>
                                <tr>
                                    <td className='border border-primary'>2</td>
                                    <td className='border border-primary text-left'>Total Partial Cash Sale/Profit</td>
                                    <td className='border border-primary'>{partialProfit?.totalSales}</td>
                                    <td className='border border-primary'>{(partialProfit?.totalSales - partialProfit?.totalProfit).toFixed(2)}</td>
                                </tr>

                            </tbody>
                            <tbody>
                                <tr>
                                    <td className='border border-primary'>3</td>
                                    <td className='border border-primary text-left'>Total Collection Sale/Profit</td>
                                    <td className='border border-primary'>{collectionProfit?.totalSales}</td>
                                    <td className='border border-primary'>{(collectionProfit?.totalSales - collectionProfit?.totalProfit).toFixed(2)}</td>
                                </tr>

                            </tbody>
                            <tbody>
                                {
                                    incomes.map((income, index) => <tr>
                                        <td className='border border-primary'>{index + 4}</td>
                                        <td className='border border-primary text-left'>{income._id}</td>
                                        <td className='border border-primary'></td>
                                        <td className='border border-primary'>{income.totalAmount}</td>
                                    </tr>)
                                }

                            </tbody>
                            <tbody>
                                <tr>
                                    <td className='border border-primary text-right font-bold' colSpan="3">Total Profit</td>
                                    <td className='border border-primary font-bold'>{(salesProfit?.totalSales - salesProfit?.totalProfit + totalIncome).toFixed(2)}</td>
                                </tr>
                            </tbody>
                            <tbody>
                                <tr>
                                    <td className='border border-primary text-right font-bold' colSpan="3">Total Expenses</td>
                                    <td className='border border-primary font-bold'>{totalExpense}</td>
                                </tr>
                            </tbody>
                            <tbody>
                                <tr>
                                    <td className='border border-primary text-right font-bold' colSpan="3">Grand Profit</td>
                                    <td className='border border-primary font-bold underline decoration-double'>{(salesProfit?.totalSales - salesProfit?.totalProfit + totalIncome - totalExpense).toFixed(2)}</td>
                                </tr>
                            </tbody>
                            <br />
                            <tbody>
                                {
                                    expenses.map((income, index) => <tr>
                                        <td className='border border-primary'>{index + 1}</td>
                                        <td className='border border-primary text-left'>{income._id}</td>
                                        <td className='border border-primary'>{income.totalAmount}</td>
                                        <td className='border border-primary'>{income.details}</td>
                                    </tr>)
                                }

                            </tbody>
                            <tbody>
                                <tr>
                                    <td className='border border-primary text-right font-bold' colSpan="2">Total Expenses</td>
                                    <td className='border border-primary font-bold'>{totalExpense}</td>
                                    <td className='border border-primary font-bold'></td>
                                </tr>
                            </tbody>

                            <tfoot>
                                <tr>
                                    <th className='bg-primary text-white normal-case'></th>
                                    <th className='bg-primary text-white normal-case'></th>
                                    <th className='bg-primary text-white normal-case'></th>
                                    <th className='bg-primary text-white text-sm'></th>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProfitStatementAdvance;